import { computed, ref } from "vue"

import type { ContainerFormData, ItemDetail } from "@/types/models"

export function useContainerEdit(item: ItemDetail) {
  const containerFormOpen = ref(false)

  const containerEditData = computed<ContainerFormData | null>(() => {
    if (!item.is_container) return null
    return {
      id: item.id,
      name: item.name,
      parent_id: item.parent?.id ?? null,
      item_type_id: item.item_type?.id ?? null,
      asset_code: item.asset_code,
      assigned_location: item.container_properties?.assigned_location ?? null,
      access_method: item.container_properties?.access_method ?? null,
      access_notes: item.container_properties?.access_notes ?? null,
    }
  })

  const hasContainerProperties =
    item.is_container &&
    item.container_properties &&
    (item.container_properties.assigned_location || item.container_properties.access_method)

  return { containerFormOpen, containerEditData, hasContainerProperties }
}
